import axios from 'axios';
import '../config';

const validId = value => Number.isSafeInteger(value) && value > 0;
const endpoint = (customerId, locationId) => {
  if (!validId(customerId) || !validId(locationId)) throw new Error('A valid customer and location are required.');
  return `${global.config.url}/admin/customers/${customerId}/locations/${locationId}/access-point-directions`;
};
const authConfig = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
const requireDirection = (data, locationId) => {
  if (!data || !validId(data.accessPointId) || data.locationId !== locationId ||
      ![null, 'Entry', 'Exit'].includes(data.direction) || !Number.isSafeInteger(data.revision) || data.revision < 0 ||
      ['tile', 'gate', 'updatedAt'].some(key => data[key] !== null && typeof data[key] !== 'string')) {
    throw new Error('The server returned an unexpected access-point direction response. Reload before making another change.');
  }
  return data;
};

const accessPointDirectionsApi = {
  /** @returns {Promise<import('./types/accessPointDirections').AccessPointDirection[]>} */
  list: async (customerId, locationId) => {
    const { data } = await axios.get(endpoint(customerId, locationId), authConfig());
    if (!Array.isArray(data)) throw new Error('The server returned an unexpected direction list.');
    const ids = new Set();
    data.forEach(item => {
      requireDirection(item, locationId);
      if (ids.has(item.accessPointId)) throw new Error('The server returned duplicate access-point directions.');
      ids.add(item.accessPointId);
    });
    return data;
  },
  /** @param {number} customerId @param {number} locationId @param {number} accessPointId
   * @param {import('./types/accessPointDirections').AccessPointDirectionRequest} request
   * @returns {Promise<import('./types/accessPointDirections').AccessPointDirection>} */
  save: async (customerId, locationId, accessPointId, request) => {
    const url = endpoint(customerId, locationId);
    if (!validId(accessPointId) || !request || !['Entry', 'Exit'].includes(request.direction) ||
        !Number.isSafeInteger(request.revision) || request.revision < 0) {
      throw new Error('Choose Entry or Exit and use the current returned revision.');
    }
    const response = await axios.put(`${url}/${accessPointId}`,
      { direction: request.direction, revision: request.revision }, authConfig());
    if (response.status !== 200) throw new Error('The server did not confirm the direction save. Reload before trying again.');
    const data = requireDirection(response.data, locationId);
    if (data.accessPointId !== accessPointId || data.direction !== request.direction) {
      throw new Error('The server did not confirm the requested access-point direction. Reload before trying again.');
    }
    return data;
  },
};
export default accessPointDirectionsApi;
